export const artTestSet: string[] = [
  "국내 여자 배우",
  "국내 남자 배우",
  "국내 영화 제목",
  "외국 영화 제목",
  "남성 아이돌 그룹",
  "여성 아이돌 그룹",
  "싱어송 라이터",
  "밴드를 구성하는 악기",
]